import { useDateFormatStore } from "@/stores/DateFormatStore";
import { dayjs } from "@/dayjs";

export const useDateTime = () => {
    const globalFormat = useDateFormatStore();
    const formattedDateTime = (dateTime: Date | string) => {
        return dayjs(dateTime).tz().format(globalFormat.globalDateTimeFormat);
    };

    const formattedDate = (dateTime: Date | string) => {
        return dayjs(dateTime).tz().format(globalFormat.globalDateFormat);
    };

    const isDate = (dateTime: Date | string) => {
        return dayjs(dateTime).isValid();
    };

    const dateIsInFuture = (futureDateTime: Date): boolean => {
        const now = dayjs();
        const future = dayjs(futureDateTime);

        return now.isBefore(future);
    };

    const iso8601 = (dateTime: Date | string) => {
        return dayjs(dateTime).format("YYYY-MM-DD[T]HH:mmZ");
    };

    const convertMinutesToDays = (minutes: number) => {
        return parseFloat(dayjs.duration(minutes, "minutes").asDays().toFixed(2));
    };

    const convertMinutesToHours = (minutes: number) => {
        return parseFloat(dayjs.duration(minutes, "minutes").asHours().toFixed(2));
    };

    const convertMinutesToDetailedDuration = (minutes: number) => {
        if (!Number.isFinite(minutes)) {
            throw new Error("Minutes must be a finite number");
        }
        if (minutes < 0) {
            throw new Error("Minutes cannot be negative");
        }

        const totalMinutes = Math.floor(minutes);
        const days = Math.floor(totalMinutes / (24 * 60));
        const hours = Math.floor((totalMinutes % (24 * 60)) / 60);
        const remainingMinutes = totalMinutes % 60;

        return {
            days,
            hours,
            minutes: remainingMinutes
        };
    };

    return {
        formattedDateTime,
        formattedDate,
        isDate,
        dateIsInFuture,
        iso8601,
        convertMinutesToDays,
        convertMinutesToHours,
        convertMinutesToDetailedDuration,
    };
};
